import { GridLegacy, Typography } from "@mui/material";
import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { useFormContext } from "react-hook-form";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import { MenuSelectionTable } from "../../Arrangements/ArrangementGroups/Tabs/Products";
import FormCheckboxTC from "../../../components/Forms/FormCheckboxTC";

function AmountOffProduct() {
  const { menukaartVestigingId } = useFormContext();

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <GridLegacy item xs={12}>
              <Typography variant={"h5"}>
                <TranslationWrapper
                  tDefault={"Amount off of a product"}
                  tKey={"voucherDef.amount_off_product.AMOUNT_OFF_PRODUCT"}
                />
              </Typography>
            </GridLegacy>
            <GridLegacy item xs={12}>
              <Typography>
                <TranslationWrapper
                  tDefault={"This will give a FIXED AMOUNT discount on the SPECIFIED PRODUCT(S)."}
                  tKey={"voucherDefs.form.amount_off_product.explanation"}
                />
              </Typography>
            </GridLegacy>

            <FormControlledInputTC
              name={"priceDiscountAmount"}
              tDefault={"Price Discount Amount"}
              tKey={"voucherDefs.form.algemeen.label.priceDiscountAmount"}
              type={"number"}
            />

            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=250&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"freeProducts_JSON" + menukaartVestigingId}
              multiple
              name={"freeProducts_JSON"}
              tDefault={"Voucherproduct (in cash desk / on ticket)"}
              tKey={"voucherDefs.form.algemeen.label.voucherProduct"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=250&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"includedProducts_JSON" + menukaartVestigingId}
              multiple
              name={"includedProducts_JSON"}
              tDefault={"Product(s) to get this discount [~]"}
              tKey={"voucherDefs.form.algemeen.label.includedProducts"}
            />
            <FormControlledInputTC
              name={"maxChooseItems"}
              tDefault={"Maximum discounted items (0 = No limit)"}
              tKey={"voucherDefs.form.algemeen.label.maxChooseItems"}
              type={"number"}
            />
            <FormControlledInputTC
              fieldProps={{
                parseFromDatabaseValue: (val) => val / 100.0,
                parseToDatabaseValue: (val) => Math.round(val * 100.0),
              }}
              name={"max_discounted_amount"}
              tDefault={"Maximal discounted amount (empty or zero = no limit)"}
              tKey={"voucherDefs.form.algemeen.label.maxDiscountedAmount"}
              type={"number"}
            />
            <FormAsyncTC
              async={{
                url: "voucher-definitions/available-categories?vestiging_id=" + menukaartVestigingId,
                searchField: "naam",
              }}
              key={"supergroups" + menukaartVestigingId}
              multiple
              name={"supergroups"}
              tDefault={"Supergroup(s) to get this discount [~]"}
              tKey={"voucherDefs.form.algemeen.label.supergroups"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=250&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"includedProducts_JSON" + menukaartVestigingId}
              multiple
              name={"includedProducts_JSON"}
              tDefault={"Product(s) to get this discount [~]"}
              tKey={"voucherDefs.form.algemeen.label.includedProducts"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=250&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"onlyifProductsInBasket_JSON" + menukaartVestigingId}
              multiple
              name={"onlyifProductsInBasket_JSON"}
              tDefault={"Only allow discount when these products are in Shopping Basket"}
              tKey={"voucherDefs.form.algemeen.label.onlyifProduct"}
            />

            <FormSwitchTC
              name={"allowOnEveryOnlyifProduct"}
              tDefault={"allowOnEveryOnlyifProduct"}
              tKey={"voucherDefs.form.algemeen.label.allowOnEveryOnlyifProduct"}
            />
          </GridLegacy>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <h4>
            <TranslationWrapper tDefault={"Menus"} tKey={"Menus"} />
          </h4>
          <Typography variant={"caption"}>
            <TranslationWrapper
              tDefault={"Not working with voucher master salesarea using other menu"}
              tKey={"Not working with voucher master salesarea using other menu"}
            />
          </Typography>
          <MenuSelectionTable />
        </CardBody>
      </Card>
    </div>
  );
}

export default AmountOffProduct;
